import { trpc } from '@/client/utils/trpc';
import type { RouterOutputs } from '@/client/utils/trpc';

type Employee = RouterOutputs['employees']['list'][number];

interface PersonTimeTabProps {
  person: Employee;
}

export function PersonTimeTab({ person }: PersonTimeTabProps) {
  const now = new Date();
  const monthName = now.toLocaleString('default', { month: 'long' });
  const year = now.getFullYear();

  const { data, isLoading } = trpc.employees.getHoursThisMonth.useQuery(
    { id: person.id },
    { enabled: !!person.id },
  );

  return (
    <div className="rounded-lg border p-8">
      <p className="text-sm text-muted-foreground">
        Hours logged in {monthName} {year}
      </p>
      <div className="tnum mt-2 text-4xl font-bold">
        {isLoading ? '—' : `${data?.total_hours ?? 0}h`}
      </div>
    </div>
  );
}
